import service from '../Common/'
import constants from '../../../settings/shared/constants'


function ExtractFile (extractdata)  {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
    return service({
      url: constants.fileapi.fileJobs.extractFile,
      method: 'POST',
      headers:headers,
      data:extractdata
    })
}

function CopyFile (copydata)  {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
  return service({
    url: constants.fileapi.fileJobs.copyFile,
    method: 'POST',
    headers:headers,
    data:copydata
  })
}

function MoveFile (movedata)  {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
  return service({
    url: constants.fileapi.fileJobs.moveFile,
    method: 'POST',
    headers:headers,
    data:movedata
  })
}
function DeleteFolder (deletedata)  {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
  return service({
    url: constants.fileapi.fileJobs.deleteFolder,
    method: 'POST',
    headers:headers,
    data:deletedata
  })
}

function TrashFolder (trashdata)  {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
  return service({
    url: constants.fileapi.fileJobs.trashFolder,
    method: 'POST',
    headers:headers,
    data:trashdata
  })
}
function RestoreFile (restoredata)  {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
  return service({
    url: constants.fileapi.fileJobs.restoreFile,
    method: 'POST',
    headers:headers,
    data:restoredata
  })
}

function RenameFile (renameData)  {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
  return service({
    url: constants.fileapi.fileJobs.renameFile,
    method: 'POST',
    headers:headers,
    data:renameData
  })
}

function SaveVersion (filedata)  {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
  return service({
    url: constants.fileapi.fileJobs.SaveFileVersion,
    method: 'POST',
    headers:headers,
    data:filedata
  })
}
function restoreVersionObjects (restoreData) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
  return service({
    url: constants.fileapi.fileJobs.restoreVersionObjects,
    method: 'POST',
    headers:headers,
    data: restoreData,
  })
}

function PendingJobs (routeKey, jobStates,  pageNumber, pageSize) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
  return service({
    url: constants.fileapi.fileJobs.getPendingJobs + '/' + routeKey + '?jobStates=' + jobStates +
      "&page=" + pageNumber + "&size=" + pageSize,
    method: 'GET',
    headers:headers,
    data: {}
  })
}

function ViewOriginalVersion (originaldata)  {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
  return service({
    url: constants.fileapi.fileJobs.ViewOriginalVersion,
    method: 'POST',
    headers:headers,
    data:originaldata
  })
}

function GetStorageJobId (storageJobId)  {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
  return service({
    url: constants.fileapi.fileJobs.GetStorageJobId+storageJobId,
    method: 'GET',
    headers:headers,
    data:''
  })
}

const FileJobsService = {
    ExtractFile,CopyFile,DeleteFolder,TrashFolder,MoveFile,RestoreFile,RenameFile,SaveVersion,restoreVersionObjects,PendingJobs,ViewOriginalVersion,GetStorageJobId
}

export default FileJobsService;